import { getMessages, type Messages } from './messages'
import { getRuntimeLocale } from './runtime'
import type { AppLocale } from './types'

/** Mensajes fuera de React (dominio, configs, hooks). */
export function translate(locale?: AppLocale): Messages {
  return getMessages(locale ?? getRuntimeLocale())
}

export function tMsg(): Messages {
  return translate()
}
